module.exports = __webpack_public_path__ + "static/media/Instagram.e4cc13f1.svg";